import {
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonSpinner,
} from "@ionic/react";
import React, { useState } from "react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";
import { useAppSelector } from "../../../Hooks";
import { selectUser } from "../../../reducers/UserReducer";
import CheckRole from "../../extras/CheckRole";
import ReportRow from "./ReportRow";
import { default as download_report_icon } from "../../../AE2/static/icons/download_report_icon.svg";

interface Props {
  uuid?: any
  row?: boolean
}

async function downloadReport(
  token: string,
  id: string,
) {
  return fetch(`${API_URL}/reports/energy_analysis/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      
    }),
  }).then(async (res: any) => {
    if (res.ok) {
      return res.blob();
    } else {
      console.log(res)
      NotificationPopUp("error", res.data, "Error Generating Report");
      return false
    }
  });
}

const EnergyAnalysisReportButton: React.FC<Props> = ({ uuid, row }) => {
  const [loading, setLoading] = useState(false);
  const user = useAppSelector(selectUser)

  const handleDownload = async () => {
    setLoading(true);
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res = await downloadReport(token, uuid,);
    if (res) {
      const url = window.URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${uuid}_Energy_Analysis_Report.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode!.removeChild(link);
    }
    setLoading(false);
  };

  if(row){
    return <ReportRow title="Energy Analysis Report" loading={loading} onClick={handleDownload}/>
  }

  if(CheckRole(user,['Customer\n','Customer'])){
    
    return <IonItem button onClick={()=>handleDownload()}>
      {loading ? 
        <IonSpinner/> :
        <IonIcon slot="start" src={download_report_icon} />}
      <IonLabel>Energy Analysis Report</IonLabel>
    </IonItem>
  }

  return (
    <IonButton
        onClick={()=>handleDownload()}
        title="Energy Analysis Report"
        shape="round"  
        color="medium"
      >
        {loading ? 
        <IonSpinner/> :
        <IonIcon slot="icon-only" src={download_report_icon} />}
      </IonButton>
  );
};

export default EnergyAnalysisReportButton;
